import { Children, isValidElement, ReactNode } from "react";
import { Option } from "../Option";
import { Group } from "../Group";
import { OptionsOrGroups } from "react-select";
import { OptionItem } from "../OptionItem";
import { GroupItem } from "../GroupItem";
import { getOptions } from "./getOptions";

/**
 * Gets the items from the specified children.
 * @param children The children to get the items from.
 * @returns The array of items.
 */
export function getItems(children: ReactNode | undefined): OptionsOrGroups<OptionItem, GroupItem> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;

      if (child.type === Option) {
        const { props } = child;
        const { label, children } = props;

        let searchText: string | undefined = undefined;
        if (label) searchText = label;
        else if (children && typeof children === "string") searchText = children;

        return {
          type: "option",
          label: child.props.children ?? child.props.label,
          searchText,
          value: child.props.value,
        } as OptionItem;
      } else if (child.type === Group) {
        return {
          type: "group",
          label: child.props.label,
          options: getOptions(child.props.children),
        } as GroupItem<OptionItem>;
      }

      console.log("Dropdown ignoring unsupported child component.");
      return null;
    })?.filter((option) => !!option) ?? []
  );
}
